import useDefinedContext from "hooks/useDefinedContext";
import YAxisActionsContext from "../contexts/YAxisActionsContext";

interface UseYAxisActionsProps {}

function useYAxisActions(props?: UseYAxisActionsProps) {
  return useDefinedContext(YAxisActionsContext);
}

export default useYAxisActions;
